import {observable} from "mobx";
import DB from "./DB";
import Tracker from "./Tracker";

var _ = require('lodash');

let store = observable({
  leagueGameDay: null,
  division: null, // actually pool
  round: null,
  // division: DB.divisions[2].pools[0],
  tab: null,

  setDivision: (d, t) => {
    store.division = d;
    if (d)
      addRoute(`/p/${d.id}/${t}`);
    else
      addRoute("");
  },

  setLeagueGameDay: (lgd) => {
    store.leagueGameDay = lgd;

    if (lgd)
      addRoute(`/gd/${lgd.id}`);
    else
      addRoute("");
  },

  setTab: (t, saveUrl) => {
    store.tab = t;
    Tracker.track("division." + t);

    if (saveUrl) {
      addRoute(`/p/${store.division.id}/${t}`);
    }
  }
});

let addRoute = (s) => {
  let {pathname} = window.location;

  let url;
  if (gon.tournament)
    url = `/tournaments/${gon.tournament.tid}` + s;
  if (gon.league)
    url = `/leagues/${gon.league.uuid}` + s;

  if (pathname !== url)
    history.pushState({}, "", url);
}

let actOnRoute = () => {
  let {pathname} = window.location;

  let m;

  m = pathname.match(/leagues\/\w+$/)
  if (store.leagueGameDay && m) {
    store.setLeagueGameDay(null);
    return;
  }

  m = pathname.match(/leagues\/\w+\/gd\/(\d+)/)
  if (m) {
    store.setLeagueGameDay(_.find(DB.league.sessions, {id: parseInt(m[1])}));
    return;
  }

  m = pathname.match(/tournaments\/[\w-]+(\/p\/)?(\d+)?\/?(\w+)?/);
  if (!m)
    return;

  if (m[2]) {
    store.division = _.find(_.flatMap(DB.divisions, 'pools'), { id: parseInt(m[2])});

    if (m[3])
      store.tab = m[3];
    else
      store.tab = "schedule";
  }
}

window.addEventListener('popstate', actOnRoute);
actOnRoute();

export default store;
